import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Globe, ArrowRight } from "lucide-react";
import { useI18n } from "@/context/I18nContext";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

export default function Countries() {
  const { t, lang } = useI18n();
  const [countries, setCountries] = useState([]);
  useEffect(() => { api.get("/countries").then(({ data }) => setCountries(data)); }, []);
  const cName = (c) => (lang === "it" ? c.name_it : c.name_en);

  return (
    <div className="max-w-6xl mx-auto px-4 py-12">
      <h1 className="font-heading text-3xl font-black tracking-tighter">{t("countries.title")}</h1>
      <p className="text-muted-foreground mt-2 max-w-2xl">{t("countries.subtitle")}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-8">
        {countries.map((c) => (
          <Link key={c.code} to={`/country/${c.code}`} data-testid={`country-${c.code}`}
            className="group rounded-lg border border-border bg-card p-6 flex items-center justify-between transition-all hover:-translate-y-1 hover:shadow-md">
            <div className="flex items-center gap-3">
              <div className="h-11 w-11 rounded-md bg-primary/10 flex items-center justify-center"><Globe className="h-5 w-5 text-primary" /></div>
              <div>
                <div className="font-heading font-bold text-lg">{cName(c)}</div>
                <div className="text-xs uppercase tracking-wider text-muted-foreground">{c.code}</div>
              </div>
            </div>
            <ArrowRight className="h-5 w-5 text-primary transition-transform group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </div>
  );
}
